import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navigation from '../navigation/navigationVisiteur';
import CloseButton from 'react-bootstrap/CloseButton';
import { useCallback } from 'react';
import PostSupprimer from './postSupprimer';

function PostAffichage(props) {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [reponse,setResponse] = useState("");
    const [photo,setPhoto] = useState(false);
    const [selectpost,setSelectpost] = useState("");
    const [photo_,setPhoto_] = useState("");
    const [isLoadingPost, setIsLoadingPost] = useState(false);
    const [page, setPage] = useState(0);
    const [fin, setFin] = useState(false);
    const apiUrl = process.env.REACT_APP_API_URL;


    useEffect(() => {
        setIsLoading(true);
        const fetchData = async () => {
            try {
                const response = await axios.post(
                    `${apiUrl}/post/affichage`,
                    {
                        idEquipe : props.userData.user.donnée.results[0].id_equipe,
                        page : 0
                    },
                    {
                        withCredentials: true 
                    }
                );
                setError(null);
                setIsLoading(false);
                setResponse(response.data);
            } catch (error) {
                setError(error.response);
                setIsLoading(false);
            }
        };

        fetchData(); 
    }, [props.userData, setIsLoading, setError, apiUrl]);

    const handlePhotoClick = (postId) => {
        const selected = reponse.post.find((post) => post.id_post === postId);
        setSelectpost(selected);
        setPhoto(true);
        window.scrollTo({ top: 0 });
    };

    const handleScroll = useCallback(() => {
        const { scrollTop, clientHeight, scrollHeight } = document.documentElement || document.body;
        if (scrollTop + clientHeight >= scrollHeight - 50 && !isLoadingPost) {
            setIsLoadingPost(true);
            axios.post(`${apiUrl}/post/affichage`, {
                idEquipe: props.userData.user.donnée.results[0].id_equipe,
                page: page + 10
            }, {
                withCredentials: true
            }).then(response => {
                if (reponse && response.data.post.length > 0) {
                    setPage(page + 10);
                    setResponse(prevResponse => {
                        const updatedResponse = { ...prevResponse, post: [...prevResponse.post, ...response.data.post] };
                        return updatedResponse;
                    });
                } else if (response.data.post.length === 0) {
                    setFin(true);
                }
            }).catch(error => {
                console.error('Erreur lors du chargement des éléments suivants', error);
            }).finally(() => {
                setIsLoadingPost(false);
            });
        }
    }, [apiUrl, isLoadingPost, page, props.userData.user.donnée.results, reponse]);

    useEffect(() => {
        if(fin === false){
            window.addEventListener('scroll', handleScroll);
        }
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isLoadingPost, handleScroll, fin]);

    if (isLoading) {
        return (
            <div className="centered-content">
                <img src="/img/logo.png" alt="Logo" className="centered-logo" />
                <br/>
                <span className="loader"></span>
            </div>
        );  
    }

    const ScrollOn = () => {
        document.body.style.overflow = 'auto';
    };

    const ScrollOff = () => {
        document.body.style.overflow = 'hidden';
    };

    return (
        <>
            {props.userData ? (
                <>
                    {photo && (
                        <>
                            {photo_ && (
                                <>
                                    <div className="images selected" onClick={() => {setPhoto_("");ScrollOn()}}>
                                        <CloseButton className="quit" onClick={() => {setPhoto_("");ScrollOn()}}/>
                                        <img onClick={(event) => { event.stopPropagation(); }} src={`${apiUrl}/image/post/${selectpost.repertoire}/${photo_}`} alt="post selectionné " />
                                    </div>
                                </>
                            )}
                            <img onClick={() => {setPhoto(false);setSelectpost('')}} className="post_retour" alt='icone retour' src='/img/retour.png'/>
                            <div className="publi" id={`post-${selectpost.id_post}`}>
                                <div className="publi2">
                                    <div className="nom1">
                                        <img src={`${apiUrl}/image/equipe/${selectpost.logo}`} alt="logo de l'équipe" />
                                    </div>
                                    <div>
                                        <h3><a href={`/${props.type}/equipe/coach/${selectpost.id}`} target="_blank" rel="noopener noreferrer">{selectpost.nom} {selectpost.prenom}</a></h3>
                                        <p className="date">{selectpost.date} {selectpost.audience === "public" ? (<img src="/img/public.jpg" alt='icone terre'/>) : (<img src="/img/privé.jpg" alt='icone cadenas'/>)}</p>
                                    </div>
                                </div>
                                <div className="public">
                                    <p>{selectpost.texte}</p>
                                    {selectpost.photos && selectpost.photos.split(',').map((photo, index) => (
                                        <div key={index}>
                                            <div className="images" >
                                                <img onClick={() => {setPhoto_(photo);ScrollOff();}} alt='img post selectionner' src={`${apiUrl}/image/post/${selectpost.repertoire}/${photo}`} />
                                            </div>
                                            <br/>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    )}
                    {reponse && photo === false && reponse.post.map((reponse, index) => (
                        <div key={index}>
                            <div className="publi">
                                <div className="publi2">
                                    <div className="nom1">
                                        <img src={`${apiUrl}/image/equipe/${reponse.logo}`} alt="logo l'équipe" />
                                    </div>
                                    <div>
                                        <h3><a href={`/${props.type}/equipe/coach/${reponse.id}`} target="_blank" rel="noopener noreferrer">{reponse.nom} {reponse.prenom}</a></h3>
                                        <p className="date">{reponse.date} {reponse.audience === "public" ? (<img src="/img/public.jpg" alt='icone de la terre'/>) : (<img alt="icone cadenas" src="/img/privé.jpg"/>)}</p>
                                    </div>
                                    {reponse.id_createur === props.userData.user.donnée.results[0].id && reponse.type_createur === props.type && (
                                        <PostSupprimer userData={props.userData} post={reponse} type={props.type} />
                                    )}
                                </div>
                                <div className="public">
                                    <p>{reponse.texte}</p>
                                    {reponse.photos && reponse.photos.split(',')[0] && (
                                        <div className="images">
                                            <img onClick={() => handlePhotoClick(reponse.id_post)} src={`${apiUrl}/image/post/${reponse.repertoire}/${reponse.photos.split(',')[0]}`}  alt='post'/>
                                            <p>* Cliquer sur l'image pour voir les autres images</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <br/>
                        </div>
                    ))}
                    {isLoadingPost && (
                        <>
                            <br/>
                            <div className="loading-post">
                                <div className="point point1"></div>
                                <div className="point point2"></div>
                                <div className="point point3"></div>
                            </div>
                        </>
                    )}
                    {fin && (
                        <>
                            <br/>
                            <div className='fin'>
                                <p>Plus aucun post n'est disponible.</p>
                            </div>
                        </>
                    )}
                </>
            ) : (
                <>
                    <Navigation/>        
                    <div id="alert-message" className="alert" >
                        <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
                    </div>
                </>
            )}
        </>
    );
}

export default PostAffichage;

